import React from 'react';
import PageLayout from '../../components/PageLayout';
import _t from 'counterpart';
import { loadTransaction } from '../../services/BackendService';
import { useQuery } from 'react-query';
import { extractErrorMessage, formatCurrency, formatDateTime } from '../../helpers';
import { useParams } from 'react-router';
import Loading from '../../components/Loading';
import Error from '../../components/Error';
import { CRow, CCol, CCard, CCardBody, CLink } from '@coreui/react';
import Description from '../../components/Description';
import toast from 'react-hot-toast';

const CommissionTransactionPage = () => {
  const { id } = useParams<{ id: string }>();

  const transactionQuery = useQuery(['transaction-page', id], () => loadTransaction(id), {
    onError: (error: any) => {
      const msg = extractErrorMessage(error);
      toast.error(msg);
    },
  });
  const { isLoading, isError, data, refetch } = transactionQuery;

  if (isLoading || !data) {
    return <Loading />;
  }

  if (isError) {
    return <Error onRetry={refetch} />;
  }

  const { id: transactionId, type, status, amount, currency, createdAt, affiliateCommission } = data;

  return (
    <PageLayout title={_t('commissions.commission-transaction-details')}>
      <CRow>
        <CCol md={12}>
          <CCard>
            <CCardBody>
              <CRow>
                <Description title={_t('global.id')}>{transactionId}</Description>
                <Description title={_t('global.type')}>{type}</Description>
              </CRow>
              <CRow>
                <Description title={_t('global.status')}>{status}</Description>
                <Description title={_t('global.amount')}>{formatCurrency(amount, currency)}</Description>
              </CRow>
              <CRow>
                <Description title={_t('global.currency')}>{currency}</Description>
                <Description title={_t('global.date')}>{formatDateTime(createdAt)}</Description>
              </CRow>
              {affiliateCommission && (
                <>
                  <CRow>
                    <Description title={_t('commissions.introducer')}>
                      {affiliateCommission.introducerName ? (
                        <CLink href={`/customers/${affiliateCommission.introducerId}`}>
                          {affiliateCommission.introducerName}
                        </CLink>
                      ) : (
                        '-'
                      )}
                    </Description>
                    <Description title={_t('commissions.referral')}>
                      {affiliateCommission.referralName ? (
                        <CLink href={`/customers/${affiliateCommission.referralId}`}>
                          {affiliateCommission.referralName}
                        </CLink>
                      ) : (
                        '-'
                      )}
                    </Description>
                  </CRow>
                  <CRow>
                    <Description title={_t('commissions.commission-type')}>
                      {affiliateCommission.commissionType}
                    </Description>
                    <Description title={_t('commissions.action-type')}>{affiliateCommission.actionType}</Description>
                  </CRow>
                  <CRow>
                    <Description title={_t('commissions.action-details')}>
                      {affiliateCommission.actionDetails}
                    </Description>
                  </CRow>
                </>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </PageLayout>
  );
};

export default CommissionTransactionPage;
